import { object, string } from 'yup'

export const addEquipmentFormSchema = object().shape({
  equipmentType: string()
    .oneOf(['TRACTOR', 'TRAILER'], 'Please select either Tractor or Trailer')
    .required('Type is a required field')
    .default('TRACTOR'),
  unitNumber: string()
    .required('Unit number is a required field')
    .matches(
      /^[A-Z0-9 -]+$/,
      'Unit number can only include letters, numbers, spaces and dashes'
    )
    .default(''),
  equipmentTypeCode: string()
    .matches(/^[A-Z0-9]{2}$/, {
      excludeEmptyString: true,
      message: 'Equipment type code must be 2 letters or numbers',
    })
    .optional()
    .default(''),
  licensePlateNumber: string().optional().default(''),
  stateProvince: string().optional().default(''),
  vinNumber: string()
    .matches(/^[A-Z0-9]{17}$/, {
      excludeEmptyString: true,
      message: 'VIN must be 17 alphanumeric characters',
    })
    .optional()
    .default(''),
})
